/**
 * 티켓 본문을 마크다운으로 그린다(2026-10-18 UI 회의 1차 묶음).
 *
 * AI 채팅 초안이 `## 재현 절차` 같은 절로 본문을 쓰는데, 상세가 원문을
 * 그대로 보여 줘서 `##` 가 글자로 읽혔다. 상세와 만들기 폼의 미리보기가
 * 이 하나를 같이 쓴다 — 둘이 다르게 그리면 「미리 본 것과 만든 것」이 갈린다.
 *
 * ⚠ **원시 HTML 을 그리지 않는다.** `react-markdown` 기본값이 HTML 을
 * 글자로 두므로 `rehype-raw` 를 붙이지 마라 — 본문은 누구나 쓰는 칸이다.
 */

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function Markdown({ children }: { children: string }) {
  return (
    <div className="md-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // 본문 링크는 새 창으로 — 모달 안에서 이동하면 쓰던 상세가 사라진다.
          a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noreferrer" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
